import api from '../config/axiosConfig';

const requests = new Map();
// Share only concurrent reads; every refresh obtains a new server snapshot.
export function readDriverSetup(account) {
  if (requests.has(account)) return requests.get(account);
  const request = api.get('/driver/onboarding').then(response => {
    const value = response.data?.data;
    if (response.data?.success !== true || typeof value?.dispatchEligible !== 'boolean') {
      throw new Error('Could not confirm driver setup. Refresh to try again.');
    }
    return value;
  }).finally(() => { if (requests.get(account) === request) requests.delete(account); });
  requests.set(account, request);
  return request;
}
